import { Trans } from 'react-i18next';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { NotificationMessageBlock } from '@notifications/components/NotificationMessageBlock';
import { CompetitionSessionCancelledNotificationData } from './interfaces';
import { formatLocaleDateAtTime } from '@helpers/dateHelpers';

const isCompetitionSessionCancelledPayload = (
  payload: unknown
): payload is CompetitionSessionCancelledNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'competitionName' in payload &&
    typeof payload.competitionName === 'string' &&
    'cancellationReason' in payload &&
    typeof payload.cancellationReason === 'string'
  );
};

export const competitionSessionCancelledPresenter: NotificationPresenter<CompetitionSessionCancelledNotificationData> =
  {
    type: 'competition-session-cancelled',
    icon: EmojiEventsIcon,
    badgeIcon: EventBusyIcon,
    isPayload: isCompetitionSessionCancelledPayload,
    label: (payload, t) =>
      t('notifications:types.competition-session-cancelled', {
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.competition-session-cancelled"
        values={{
          competitionName: payload.competitionName,
          sessionHeldOn: formatLocaleDateAtTime(payload.sessionHeldOn),
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    body: (payload) => {
      const reason = payload.cancellationReason?.trim();

      if (!reason) {
        return null;
      }

      return <NotificationMessageBlock>{reason}</NotificationMessageBlock>;
    },
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return ROUTES.portal.competitions.details(payload.competitionSlug);
    },
  };
